const PencilIcon = ({ className }) => (
    <div className={className}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 14 14"
            id="Pencil--Streamline-Flex"
        >
            <desc>{'Pencil Streamline Icon: https://streamlinehq.com'}</desc>
            <g id="pencil--change-edit-modify-pencil-write-writing">
                <path
                    id="Vector"
                    fillRule="evenodd"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="m5.88173 12.256 6.82147 -6.54546c1.1338 -1.08799 1.0462 -3.01396 -0.1934 -4.24897C11.2994 0.255643 9.45335 0.172777 8.38642 1.27647L1.75098 8.14056s1.46989 0.59268 2.50288 1.62184c1.03299 1.0292 1.62787 2.4936 1.62787 2.4936Z"
                    clipRule="evenodd"
                    strokeWidth={1}
                />
                <path
                    id="Vector_2"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="m1.19279 13.4838 4.6851 -1.2222s-0.59354 -1.465 -1.6256 -2.49512C3.22024 8.73636 1.75088 8.14233 1.75088 8.14233L0.516751 12.8035c-0.103018 0.3891 0.287182 0.7817 0.676039 0.6803Z"
                    strokeWidth={1}
                />
            </g>
        </svg>
    </div>
);

export default PencilIcon;
